<template>
  <one-column-layout>

    <title-bar :title="title"
               type="sub" :back-button="hasBack"
               slot="titleBar"
               @back="emitBack">
    </title-bar>

    <div slot="subtitleBar">
      <div class="form--search">
        <i class="smd-icon-action-search"/>
        <input type="text" placeholder="Search" v-model="searchTerm" @input="onSearchChange">
      </div>
    </div>

    <div class="form--selection" v-for="category in separatedDisplay" :key="category[idField]">
      <label>{{category[nameField]}}</label>
      <div :class="{'form--selection__row':true, 'isDisabled': item['hidden'] === true}" v-for="item in category[nestedArrField].filter(x => x.hidden === false)" :key="item[idField]">
        <smd-checkbox :id="item[idField]"
                      v-model="selected_list"
                      :data="{ [categoryField]: ((category[idField] === -1) ? item[categoryField] : category[idField]), [itemField]: item[idField], [othersField]:null}"
                      :replace-value="true"
                      :disabled="item['hidden'] === true"
        >
          <span :class="{isDisabled: item['hidden'] === true}">{{item[nameField]}}</span> <span :class="{isDisabled: item['hidden'] === true}" v-if="item['hidden'] === true">&nbsp;&nbsp;(PHASED OUT)</span>
        </smd-checkbox>
      </div>
    </div>


  </one-column-layout>
</template>

<script>
  import {deepFilterList, separateSelectedInList} from "../utilities/utilityOperators";

  export default {
    name: "smd-full-checkbox-list",
    props: {
      title:{},
      hasBack                : {type:Boolean, default: false},
      idField                : {type:String, default: 'id'},
      nameField              : {type:String, default: 'name'},
      nestedArrField         : {type:String, default: 'conditions'},
      categoryField          : {type:String, default: 'categoryId'},
      itemField              : {type:String, default: 'conditionId'},
      othersField            : {type:String, default: 'others'},
      refList                : {required: true},
      selectedListGetter     : {type:String, required: true},
      beforeListAction       : {type:Function, required:false, default: null},
      selectedListAction     : {type:String, required: false},
      selectedListMutation   : {type:String, required: false}
    },
    data() {
      return {
        searchTerm: "",
        pInitial: null
      };
    },
    computed: {
      initial() {
        return this.pInitial == null ? {} : this.pInitial
      },
      selected_list: {
        get() {
          let value = this.$store.getters[this.selectedListGetter]
          return value == null ? {} : value
        },
        set(newValue) {
          const transformedValue = this.beforeListAction ? this.beforeListAction(newValue) : newValue;
          return this.selectedListAction ? this.$store.dispatch(this.selectedListAction, transformedValue)
            : (this.selectedListMutation ? this.$store.commit(this.selectedListMutation, transformedValue)
              : undefined)
        }
      },
      filteredList() {
        let searchTerm = this.searchTerm.trim()
        if (searchTerm.length > 0) {
          return deepFilterList(true)(this.nameField)(this.nestedArrField)(this.refList)(searchTerm)
        } else {
          return this.refList
        }
      },
      separatedDisplay() {
        let separateList = separateSelectedInList({[this.idField]:-1,[this.nameField]:"Previously Selected", [this.nestedArrField]: [] })(this.nestedArrField)(this.idField)
        let results = separateList(this.filteredList)(this.initial);
        return (results.selected[this.nestedArrField].length > 0 ? [results.selected] : []).concat(results.unselected)
      }
    },
    mounted() {
      this.initializeList();
    },
    watch: {
      selected_list(newValue) {
        if (this.pInitial == null && newValue != null) {
          this.pInitial = Object.assign({}, newValue)
        }
      },
      selectedListGetter() {
        this.initializeList();
      }
    },
    methods: {
      emitBack(e) {
        this.$emit('back', e)
      },
      initializeList() {
        this.pInitial = this.selected_list != null ? Object.assign({},this.selected_list) : null;
      },
      setSearchTerm(newTerm) {
        if (this.searchTerm !== newTerm)
          this.searchTerm = newTerm;
      },
      onSearchChange(event) {
        this.$emit('search-change', event.target.value);
      }
    }
  }
</script>

<style scoped>
  .isDisabled {
    font-style: italic;
    background: #ededed!important;
    color: #a6a6a6!important;
    cursor: text;
    pointer-events: none;
  }
</style>
